var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.id)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.callDelete}},[_vm._v(" Eliminar ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }